import { Type } from '@angular/core';

import { ButtonComponent } from './components/button/button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { CodeInputComponent } from './components/code-input/code-input.component';
import { DialogActionsDirective, DialogComponent } from './components/dialog/dialog.component';
import { FilterPanelComponent } from './components/filter-panel/filter-panel.component';
import { IconComponent } from './components/icon/icon.component';
import { ListboxComponent } from './components/listbox/listbox.component';
import { TextFieldComponent } from './components/text-field/text-field.component';

export const DESIGN_SYSTEM_COMPONENTS: Type<unknown>[] = [
  ButtonComponent,
  CheckboxComponent,
  CodeInputComponent,
  DialogActionsDirective,
  DialogComponent,
  FilterPanelComponent,
  IconComponent,
  ListboxComponent,
  TextFieldComponent,
];
